export class RegisterItem {
    constructor (
        public IdCliente:string,
        public CertificateNumber:string,
        public DeviceTypeCode:string,
        public ItemDescription:string,
        public Manufacturer:string,
        public Model:string, 
        public PurchasePrice:string,
        public PurchasedDate:string,
        public RegisteredItemName:string,
        public RegistrationDate:string,
        public RetailPrice:string,
        public SerialNumber:string,
        public R3Fechaservicio:string,
        public poliza:string,
        public DealerCode: string,
        public CompanyCode: string
    ){}
}
